import React from 'react';
import { NavigationSection } from '@/config/navigation';

interface PageSectionProps {
  section: NavigationSection;
  children: React.ReactNode;
}

export function PageSection({ section, children }: PageSectionProps) {
  return (
    <div className="h-full">
      <div className="flex flex-col h-full">
        <div className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-10">
          <div className="p-2">
            <h1 className="text-2xl font-semibold tracking-tight">{section.title}</h1>
            <p className="text-sm text-muted-foreground">
              {section.subtitle}
            </p>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-0">
          {children}
        </div>
      </div>
    </div>
  );
} 